import type { KnownSummary } from '../lib/cache';

/**
 * Свежайшая известная сводка каждой записи и момент, на который она верна (ТЗ главной § 22.9): у ответа
 * списка, опроса и детали — когда ушёл запрос, у SSE и ответа «Создать» — когда пришло. По ней ответ,
 * посчитанный раньше SSE, не откатывает запись («готово» → «генерируем» → «готово» и вспышка строки).
 * Только в памяти; при смене ученика обнуляется вместе со слежением.
 */
export const knownSummaries = new Map<string, KnownSummary>();

export function forgetKnownSummaries(): void {
  knownSummaries.clear();
}
